// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickImageInput_container__bmNXy {
  width: max-content;
  --borderRadius: 0.5em;
  display: grid;
  height: 15em;
  width: 15em;
  grid-template: "img" 1fr "leg" auto;
  grid-row-gap: 0.5em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: var(--borderRadius);
  color: var(--gray);
  background: var(--lightgray);
  transition: all 0.2s;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M.ClickImageInput_hasImg__y9cHZ {
  border-radius: 0;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M.ClickImageInput_hasImg__y9cHZ .ClickImageInput_imgInputLabel__tJESB {
  border-radius: 0;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_altBtn__MBihj {
  position: absolute;
  top: -3em;
  transition: all 0.2s;
  width: 100%;
  display: flex;
  justify-content: center;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_altBtn__MBihj svg {
  font-size: 1em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_altBtn__MBihj:focus-within {
  top: 0;
  background: rgba(0, 0, 0, 0.7);
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M:hover .ClickImageInput_altBtn__MBihj {
  background: rgba(0, 0, 0, 0.7);
  top: 0;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_img__smQZO {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M svg {
  font-size: 5em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInput__UEmfL {
  position: absolute;
  left: -1000em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInputLabel__tJESB {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  bottom: -5em;
  width: 100%;
  left: 0;
  border-bottom-left-radius: var(--borderRadius);
  border-bottom-right-radius: var(--borderRadius);
  transition: all 0.2s;
  cursor: pointer;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInputLabel__tJESB p {
  margin: 0.25em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInputLabel__tJESB svg {
  font-size: 1.25em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M:hover .ClickImageInput_imgInput__UEmfL:not([disabled]) + label,
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInput__UEmfL.focus-visible:not([disabled]) + label {
  left: 0;
  bottom: 0em;
  height: 30%;
  background: rgba(0, 0, 0, 0.7);
  color: var(--white);
  font-size: 1em;
}
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M .ClickImageInput_imgInput__UEmfL.focus-visible + label:after,
.ClickImageInput_container__bmNXy .ClickImageInput_imgContainer__Vg01M label:hover:after {
  content: "";
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0;
  top: 0px;
  border: 4px solid var(--darkblueAlpha);
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ {
  position: relative;
  height: calc(var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 * var(--borderWidth));
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh {
  position: absolute;
  font-size: 1em;
  border: none;
  border: 2px dashed var(--gray);
  line-height: var(--lineHeight);
  width: 100%;
  resize: none;
  background: none;
  border-radius: 4px;
  padding: var(--paddingBottomTop) 0.5em;
  z-index: 1;
  overflow: hidden;
  min-height: calc(var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 * var(--borderWidth));
  max-height: calc(var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 * var(--borderWidth));
  line-height: calc(var(--lineHeight));
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh.ClickImageInput_captionOverflowed__0nSv6 {
  border-color: var(--danger);
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh::placeholder {
  color: var(--gray);
  font-style: italic;
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh.ClickImageInput_readOnly__uV-Z3 {
  border: 2px solid transparent;
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh:focus, .ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh.focus-visible {
  outline: none;
  border-color: var(--blue);
  border-style: solid;
  max-height: calc(15 * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 * var(--borderWidth));
  background: var(--whiteAlpha);
}
.ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh:focus.ClickImageInput_captionOverflowed__0nSv6, .ClickImageInput_container__bmNXy .ClickImageInput_captionWrapper__qC3lZ .ClickImageInput_captionInput__InDDh.focus-visible.ClickImageInput_captionOverflowed__0nSv6 {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.7);
  border-color: var(--danger);
  border-style: solid;
}

.ClickImageInput_altTxtWrappper__LsUdk {
  display: block;
  position: relative;
  z-index: 2;
  padding: 0.5em;
  background: rgba(0, 0, 0, 0.7);
  border-radius: var(--borderRadius);
  transition: opacity 0.2s;
}
.ClickImageInput_altTxtWrappper__LsUdk .ClickImageInput_altTxt__0As3l {
  width: 100%;
  resize: none;
  padding: 0.5em;
  border: 1px solid var(--black);
  border-radius: 4px;
  line-height: 1.5em;
  font-size: 1em;
}
.ClickImageInput_altTxtWrappper__LsUdk .ClickImageInput_altTxt__0As3l::placeholder {
  color: var(--gray);
  font-weight: lighter;
  font-style: italic;
}
.ClickImageInput_altTxtWrappper__LsUdk .ClickImageInput_altTxt__0As3l.ClickImageInput_hidden__EIptz {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickImageInput.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,mBAAA;AACF;AAAE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,4BAAA;EACA,oBAAA;AAEJ;AADI;EACE,gBAAA;AAGN;AAFM;EACE,gBAAA;AAIR;AADI;EACE,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAGN;AAFM;EACE,cAAA;AAIR;AAFM;EACE,MAAA;EACA,8BAAA;AAIR;AADI;EACE,8BAAA;EACA,MAAA;AAGN;AADI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAGN;AADI;EACE,cAAA;AAGN;AADI;EACE,kBAAA;EACA,aAAA;AAGN;AADI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,8CAAA;EACA,+CAAA;EACA,oBAAA;EACA,eAAA;AAGN;AAFM;EACE,cAAA;AAIR;AAFM;EACE,iBAAA;AAIR;AADI;;EAEE,OAAA;EACA,WAAA;EACA,WAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;AAEN;AAAI;;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,sCAAA;AAEN;AACE;EACE,kBAAA;EACA,wGAAA;AACJ;AAGI;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,UAAA;EACA,gBAAA;EACA,4GAAA;EAIA,4GAAA;EAIA,oCAAA;AAPN;AAQM;EACE,2BAAA;AANR;AASM;EACE,kBAAA;EACA,kBAAA;AAPR;AASM;EACE,6BAAA;AAPR;AASM;EAEE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,+FAAA;EAIA,6BAAA;AAXR;AAYQ;EACE,sCAAA;EACA,2BAAA;EACA,mBAAA;AAVV;;AAgBA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,8BAAA;EACA,kCAAA;EACA,wBAAA;AAbF;AAcE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAZJ;AAaI;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;AAXN;AAaI;EACE,aAAA;AAXN","sourcesContent":[".container {\n  width: max-content;\n  --borderRadius: 0.5em;\n  display: grid;\n  height: 15em;\n  width: 15em;\n  grid-template: \"img\" 1fr \"leg\" auto;\n  grid-row-gap: 0.5em;\n  .imgContainer {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    border-radius: var(--borderRadius);\n    color: var(--gray);\n    background: var(--lightgray);\n    transition: all 0.2s;\n    &.hasImg {\n      border-radius: 0;\n      .imgInputLabel {\n        border-radius: 0;\n      }\n    }\n    .altBtn {\n      position: absolute;\n      top: -3em;\n      transition: all 0.2s;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      svg {\n        font-size: 1em;\n      }\n      &:focus-within {\n        top: 0;\n        background: rgba(0, 0, 0, 0.7);\n      }\n    }\n    &:hover .altBtn {\n      background: rgba(0, 0, 0, 0.7);\n      top: 0;\n    }\n    .img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n    svg {\n      font-size: 5em;\n    }\n    .imgInput {\n      position: absolute;\n      left: -1000em;\n    }\n    .imgInputLabel {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      position: absolute;\n      bottom: -5em;\n      width: 100%;\n      left: 0;\n      border-bottom-left-radius: var(--borderRadius);\n      border-bottom-right-radius: var(--borderRadius);\n      transition: all 0.2s;\n      cursor: pointer;\n      p {\n        margin: 0.25em;\n      }\n      svg {\n        font-size: 1.25em;\n      }\n    }\n    &:hover .imgInput:not([disabled]) + label,\n    .imgInput:global(.focus-visible):not([disabled]) + label {\n      left: 0;\n      bottom: 0em;\n      height: 30%;\n\n      background: rgba(0, 0, 0, 0.7);\n      color: var(--white);\n      font-size: 1em;\n    }\n    .imgInput:global(.focus-visible) + label:after,\n    label:hover:after {\n      content: \"\";\n      position: absolute;\n      left: 0px;\n      right: 0px;\n      bottom: 0;\n      top: 0px;\n      border: 4px solid var(--darkblueAlpha);\n    }\n  }\n  .captionWrapper {\n    position: relative;\n    height: calc(\n      var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 *\n        var(--borderWidth)\n    );\n    .captionInput {\n      position: absolute;\n      font-size: 1em;\n      border: none;\n      border: 2px dashed var(--gray);\n      line-height: var(--lineHeight);\n      width: 100%;\n      resize: none;\n      background: none;\n      border-radius: 4px;\n      padding: var(--paddingBottomTop) 0.5em;\n      z-index: 1;\n      overflow: hidden;\n      min-height: calc(\n        var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 *\n          var(--borderWidth)\n      );\n      max-height: calc(\n        var(--maxLines) * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 *\n          var(--borderWidth)\n      );\n      line-height: calc(var(--lineHeight));\n      &.captionOverflowed {\n        border-color: var(--danger);\n      }\n\n      &::placeholder {\n        color: var(--gray);\n        font-style: italic;\n      }\n      &.readOnly {\n        border: 2px solid transparent;\n      }\n      &:focus,\n      &:global(.focus-visible) {\n        outline: none;\n        border-color: var(--blue);\n        border-style: solid;\n        max-height: calc(\n          15 * var(--lineHeight) + 2 * var(--paddingBottomTop) + 2 *\n            var(--borderWidth)\n        );\n        background: var(--whiteAlpha);\n        &.captionOverflowed {\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.7);\n          border-color: var(--danger);\n          border-style: solid;\n        }\n      }\n    }\n  }\n}\n.altTxtWrappper {\n  display: block;\n  position: relative;\n  z-index: 2;\n  padding: 0.5em;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: var(--borderRadius);\n  transition: opacity 0.2s;\n  .altTxt {\n    width: 100%;\n    resize: none;\n    padding: 0.5em;\n    border: 1px solid var(--black);\n    border-radius: 4px;\n    line-height: 1.5em;\n    font-size: 1em;\n    &::placeholder {\n      color: var(--gray);\n      font-weight: lighter;\n      font-style: italic;\n    }\n    &.hidden {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClickImageInput_container__bmNXy`,
	"imgContainer": `ClickImageInput_imgContainer__Vg01M`,
	"hasImg": `ClickImageInput_hasImg__y9cHZ`,
	"imgInputLabel": `ClickImageInput_imgInputLabel__tJESB`,
	"altBtn": `ClickImageInput_altBtn__MBihj`,
	"img": `ClickImageInput_img__smQZO`,
	"imgInput": `ClickImageInput_imgInput__UEmfL`,
	"captionWrapper": `ClickImageInput_captionWrapper__qC3lZ`,
	"captionInput": `ClickImageInput_captionInput__InDDh`,
	"captionOverflowed": `ClickImageInput_captionOverflowed__0nSv6`,
	"readOnly": `ClickImageInput_readOnly__uV-Z3`,
	"altTxtWrappper": `ClickImageInput_altTxtWrappper__LsUdk`,
	"altTxt": `ClickImageInput_altTxt__0As3l`,
	"hidden": `ClickImageInput_hidden__EIptz`
};
export default ___CSS_LOADER_EXPORT___;
